import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const links = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/about", label: "About", testId: "nav-link-about" },
  { to: "/employers", label: "Employers", testId: "nav-link-employers" },
  { to: "/candidates", label: "Candidates", testId: "nav-link-candidates" },
  { to: "/services", label: "Our Services", testId: "nav-link-services" },
];

export const Logo = () => (
  <span className="inline-flex items-center gap-2.5" data-testid="nav-brand-logo" aria-label="NicheBytes">
    <svg width="30" height="25" viewBox="22 21 74 62" aria-hidden="true" focusable="false" className="shrink-0">
      <g fill="#4A5568">
        <rect x="25" y="40" width="16" height="16" rx="2" />
        <rect x="49" y="40" width="16" height="16" rx="2" />
        <rect x="25" y="64" width="16" height="16" rx="2" />
        <rect x="49" y="64" width="16" height="16" rx="2" />
      </g>
      <rect x="73" y="24" width="20" height="20" rx="3" fill="#FF5E1A" />
    </svg>
    <span className="font-display text-[1.28rem] tracking-[-0.02em] whitespace-nowrap">
      <span className="font-normal text-white">Niche</span>
      <span className="font-bold text-[#FF5E1A]">Bytes</span>
    </span>
  </span>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#24304A]/70 bg-[#0B132B]/90 backdrop-blur-xl">
      <div className="container-nb flex h-16 items-center justify-between">
        <Link to="/" aria-label="NicheBytes home" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-[#FF5E1A]" : "text-[#CBD5E1] hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/contact" data-testid="nav-cta-lets-talk" className="btn-primary hidden sm:inline-flex">
            Let's Talk <ArrowRight size={15} />
          </Link>
          <button
            data-testid="nav-mobile-menu-toggle"
            className="lg:hidden text-[#F8FAFC] p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-[#24304A] bg-[#0B132B] px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `text-base font-medium ${isActive ? "text-[#FF5E1A]" : "text-[#CBD5E1]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary w-fit">
            Let's Talk <ArrowRight size={15} />
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
